<template>
  <div v-if="cart.credit_notes && cart.credit_notes.length" id="cart-credit-notes" class="float-none mb-2 text-right">
    <p v-for="(credit_note, k) in cart.credit_notes" :key="k">
      Credit Note {{ credit_note.code }}:
      <button class="btn btn-link text-danger pt-0" @click="removeCreditNote(credit_note)" :disabled="removing[credit_note.id]"><i class="fas fa-times"></i></button>
      <span class="amount">{{ credit_note.amount | numberToRs }}</span>
    </p>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SaleCartCreditNotes',
  props: [
    'cart'
  ],
  data () {
    return {
      removing: {}
    }
  },
  methods: {
    removeCreditNote (cartCreditNote) {
      this.removing[cartCreditNote.id] = true

      let postData = {
        id: cartCreditNote.id,
        include_cart: true
      }

      axios.delete(process.env.URLS_PUBLIC_API + '/cart/' + this.$parent.cart.id + '/credit_notes', {
        data: postData
      }).then((response) => {
        this.$parent.cart = response.data.data.cart

        setTimeout(() => {
          this.$parent.setPaneHeights()
        }, 100)
      }).catch(error => {
        this.$toast.error('Failed to remove the credit note.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.removing[cartCreditNote.id] = false
      })
    }
  }
}
</script>

<style scoped>
p {
  font-size: 1.1rem;
}
p:last-child {
  margin-bottom: 0 !important;
}
.amount {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/sale/partials/CartCreditNotes.vue